import { render } from "./LinkButton.vue?vue&type=template&id=28d6c01b&ts=true"
import script from "./LinkButton.vue?vue&type=script&lang=ts"
export * from "./LinkButton.vue?vue&type=script&lang=ts"

import "./LinkButton.vue?vue&type=style&index=0&id=28d6c01b&lang=scss"

import exportComponent from "/Users/hirosuke-pi/projects/vr-jmof-front-2020/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__